export default "__VITE_ASSET__sMvb4pay__"